<template>
    <q-modal v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
        <div>
            <v-header :title="$T('order detail') + ' ' + (order.id || '')" icon="find in page">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="close"
                              :label="$T('close')"
                              @click="close"/>
                </template>
            </v-header>
            <card width="100%">

                <form @submit.prevent="onSubmit"
                      class="row gutter-sm"
                      @keydown="form.onKeydown($event)">

                    <v-input path="firstname"
                             v-model="form.firstname"
                             :label="$T('first name')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="lastname"
                             v-model="form.lastname"
                             :label="$T('last name')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="phone"
                             v-model="form.phone"
                             :label="$T('phone')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="email"
                             v-model="form.email"
                             :label="$T('email')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="ident_card_number"
                             v-model="form.ident_card_number"
                             :label="$T('id document')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-datetime path="birth_date"
                                v-model="form.birth_date"
                                :label="$T('birth date')"
                                :max="maxBirthDate"
                                :form="form"
                                class="col-md-6 col-xs-12">
                    </v-datetime>

                    <v-input path="nif"
                             v-model="form.nif"
                             :label="$T('nif')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="address"
                             v-model="form.address"
                             :label="$T('address')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="address_2"
                             v-model="form.address_2"
                             :label="$T('address 2')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="zipcode"
                             v-model="form.zipcode"
                             :label="$T('zip code')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <v-input path="city"
                             v-model="form.city"
                             :label="$T('city')"
                             :form="form"
                             class="col-md-6 col-xs-12">
                    </v-input>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md">
                        <v-button outline
                                  :label="saveText"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  :loading="form.busy"
                                  type="submit">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                    </div>

                </form>

            </card>
        </div>
    </q-modal>
</template>

<script>
    import {
        QSpinnerPuff,
        QModal
    } from 'quasar-framework'

    export default {
        components: {
            QSpinnerPuff,
            QModal
        },

        props: {
            show: Boolean,
            order: {
                type: Object,
                default: {}
            }
        },

        data() {
            return {
                modalOrder: this.show,
                form: {}
            }
        },

        watch: {
            show(newVal) {
                this.modalOrder = newVal
            }
        },

        methods: {
            close() {
                this.modalOrder = false
                this.$emit('close')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/_consumerForm.vue